import { useTranslation } from "react-i18next";
import { setLang } from "@/i18n";
import { Translate } from "@phosphor-icons/react";

/**
 * Two-state ES/EN language toggle. Persists in localStorage.
 * variant: "dark" (sidebar) | "light" (mobile bar)
 */
export default function LanguageToggle({ variant = "dark" }) {
  const { i18n } = useTranslation();
  const current = (i18n.language || "es").startsWith("en") ? "en" : "es";
  const next = current === "es" ? "en" : "es";

  const base = "inline-flex items-center gap-1 rounded-sm px-2 h-8 text-[11px] font-bold uppercase tracking-wide transition-colors";
  const styles = variant === "dark"
    ? "border border-zinc-800 text-slate-300 hover:bg-[var(--brand,#E31E24)] hover:border-[var(--brand,#E31E24)] hover:text-white"
    : "border border-slate-300 text-slate-700 hover:bg-[var(--brand,#E31E24)] hover:border-[var(--brand,#E31E24)] hover:text-white";

  return (
    <button
      onClick={() => setLang(next)}
      data-testid="lang-toggle"
      title={current === "es" ? "Switch to English" : "Cambiar a Español"}
      aria-label={current === "es" ? "Switch to English" : "Cambiar a Español"}
      className={`${base} ${styles}`}
    >
      <Translate size={14} weight="duotone" />
      <span>{current.toUpperCase()}</span>
    </button>
  );
}
